var map = {
	"./bali.jpg": 127,
	"./bandung.jpg": 128,
	"./jogja.jpg": 129,
	"./padang.jpg": 130
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*\.jpg$
// module id = 126
// module chunks = 0